import { render } from "./NetworkConnectivityReport2.vue?vue&type=template&id=28ddd1a6&scoped=true"
import script from "./NetworkConnectivityReport2.vue?vue&type=script&lang=js"
export * from "./NetworkConnectivityReport2.vue?vue&type=script&lang=js"

import "./NetworkConnectivityReport2.vue?vue&type=style&index=0&id=28ddd1a6&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ddd1a6"]])

export default __exports__